import { html, ref, when } from '@microsoft/fast-element';
import { closeIcon } from '../../styles';
import { eventDetail } from '../../utils/formatting';
import type { RightSideModal } from './right-side-modal';

export const RightSideModalTemplate = html<RightSideModal>`
  <fast-dialog
    class="right-dialog ${(x) => x.classes}"
    part="right-dialog"
    ${ref('rightDialog')}
    modal="true"
    hidden
  >
    <div class="header" tabindex="-1">
      <slot name="header-start" part="header-start"></slot>
      <zero-button
        tabindex="-1"
        appearance="stealth"
        @click="${(x) => x.closeDialog()}"
        class="closing-icon"
      >
        ${closeIcon}
      </zero-button>
      ${(x) => x.header}
      ${when(
        (x) => x.notificationDialog,
        html<RightSideModal>`
          <close-popup
            @closeModal="${(x, c) => x.toggleDialog(eventDetail(c))}"
            class="close-popup"
            header=${(x) => x.closeModalHeader}
            description=${(x) => x.closeModalDescription}
          ></close-popup>
        `
      )}
      ${when(
        (x) => x.confirmationDialog,
        html<RightSideModal>`
          <close-popup
            @closeModal="${(x, c) => x.toggleConfirmationDialog(eventDetail(c))}"
            class="close-popup"
            header=${(x) => x.confirmModalHeader}
            description=${(x) => x.confirmModalDescription}
          ></close-popup>
        `
      )}
    </div>
    <slot></slot>

    ${when(
      (x) => x.buttons === true,
      html`
            <div class="footer">
                <div><slot name="message"><slot></div>
                <slot name="buttons"><slot>
            </div>
        `
    )}
  </fast-dialog>
`;
